import React from "react";
import SectionLabel from "./SectionLabel";
import "./MiniStat.css";

export default function MiniStat({ label, value, helper }) {
  return (
    <div className="trunfo-mini-stat">
      <SectionLabel tone="mute">{label}</SectionLabel>
      <span className="trunfo-mini-stat__value">{value}</span>
      {helper && <span className="trunfo-mini-stat__helper">{helper}</span>}
    </div>
  );
}
